import { render } from "./ModalCalls.vue?vue&type=template&id=f1f04616"
import script from "./ModalCalls.vue?vue&type=script&lang=js"
export * from "./ModalCalls.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__